export class InvalidParam extends Error {
    newValue;
    /**
     * @param newValue if provided, the parameter value in question will be updated, otherwise it will be discarded.
     */
    constructor(newValue) {
        super();
        this.newValue = newValue;
    }
}
export function saneString(input) {
    return input;
}
export function saneNumber(input) {
    if (input === '')
        throw new InvalidParam();
    const output = parseInt(input, 10);
    if (Number.isNaN(output))
        throw new InvalidParam();
    const outputString = `${output}`;
    if (outputString !== input)
        throw new InvalidParam(outputString);
    return output;
}
export function saneBoolean(input) {
    if (input === 'y')
        return true;
    if (input === 'n')
        return false;
    const falsy = ['', '0', 'false', 'no'].includes(input.trim().toLowerCase());
    throw new InvalidParam(falsy ? 'n' : 'y');
}
export function saneOption(options, base = saneString) {
    return input => {
        const option = base(input);
        if (options.includes(option))
            return option;
        throw new InvalidParam();
    };
}
